import { Page } from '@/declarations/models/Page';

/**
 * The portal's preview of one version of a page (`/_m24_/preview`), as the editor's preview button opens it.
 * `base_url` is "domain/sitepath" as the page endpoint returns it; `versionCreatedAt` must match the version's own
 * `created_at` or the portal shows "not found".
 */
export function pagePreviewUrl(page: Page, versionCreatedAt?: string): string {
  const [siteDomain = '', sitePath = ''] = (page.base_url || '').split('/');
  const params = [
    `path=${sitePath}/${page.path || ''}`,
    `page_id=${page.id}`,
    `version_id=${page.active_version_id}`,
    `created_at=${versionCreatedAt || ''}`,
    'adminlink=true',
  ];
  return `//${siteDomain}/_m24_/preview?${params.join('&')}`;
}
